import React from "react";
import { errorHandler } from "@/lib/utils/errorHandler";
import { ErrorFallback } from "./ErrorFallback";

/**
 * Global error boundary component
 * Catches JavaScript errors anywhere in the child component tree
 */
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error with full context
    errorHandler.log(error, errorInfo, {
      component: this.props.componentName || "Unknown",
    });
  }

  resetErrorBoundary = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <ErrorFallback error={this.state.error} resetErrorBoundary={this.resetErrorBoundary} />
      );
    }

    return this.props.children;
  }
}

export default GlobalErrorBoundary;
